import { AppRoute } from '@/constants/routes';

export const PRODUCT_MAIL_BASE_PATH = AppRoute.Mail;
export const PRODUCT_MAIL_LAST_MAILBOX_COOKIE = 'mail_last_mailbox_slug';
export const PRODUCT_MAIL_ATTACHMENTS_FORM_DATA_NAME = 'product_mail_attachments';

export const PRODUCT_MAIL_DELIVERY_LABELS: Record<string, string> = {
    unknown: 'Unknown',
    queued: 'Queued',
    deferred: 'Deferred',
    sent: 'Sent',
    bounced: 'Bounced',
    expired: 'Expired',
};

export const PRODUCT_MAIL_DELIVERY_BADGE_TONES = {
    sent: 'accent',
    bounced: 'danger',
    expired: 'danger',
    queued: 'default',
    deferred: 'default',
    unknown: 'muted',
} as const;
